export const sorting = (a, b) => Number(a.sorting) - Number(b.sorting);
